<template>
    <div>
        <div class="title-block">
            <div class="status-label">Existing records found for:</div>
            <h2>{{stagedCandidateForm.fields.email.value}}</h2>
        </div>
        <hr/>
        <p>A candidate record for this email address already exists. Do you wish to update the existing record or create a new one?</p>
        <div class="duplicates">
            <div class="duplicate" v-for="(duplicate, index) in stagedCandidateDuplicates" :key="index">
                <DuplicateCandidate @select-id="selectUpload" v-bind="duplicate" :sfLink="duplicate.sfLink" :disabled="fetchingSc" />
            </div>
        </div>
        
        <div class="button-container text-right">
            <a href="" class="button hollow" @click.prevent="createNew">New Candidate</a>
        </div>
    </div>
</template>

<script>
    import {getStagedCandidate} from "../../apis/sthree.consultant.api"

    import DuplicateCandidate from './DuplicateCandidate';

    export default {
        name: 'DuplicateCandidates',
        components: {DuplicateCandidate},
        data() {
            return {
                fetchingSc: false
            }
        },
        computed: {
            stagedCandidateForm() {
                return this.$store.state.cvUpload.stagedCandidateForm;
            },
            stagedCandidateDuplicates() {
                return this.$store.state.cvUpload.stagedCandidateDuplicates;
            },
            stagedCandidateDiff() {
                return this.$store.state.cvUpload.stagedCandidateDiff;
            }
        },
        methods: {
            async selectUpload(val) {
                this.fetchingSc = true;
                this.$store.dispatch('startLoading');
                await getStagedCandidate(this.$route.params.id, val)
                .then((json) => {
                    this.$store.dispatch('endLoading');
                    this.$store.dispatch('generateStagedCandidateDiffs', json.stagedCandidate);
                    if ((Object.keys(this.stagedCandidateDiff).length) > 0) {
                        this.$store.dispatch('openModal', {
                            componentName: 'Diff',
                            componentProps: {
                                diffStagedCandidate: json.stagedCandidate
                            }
                        });
                    } else {
                        this.$store.commit('setStagedCandidateFormField',{field: 'forCandidateId', value: json.externalId});
                        this.$store.commit('setStagedCandidate', json.stagedCandidate);
                        // if(this.stagedCandidateForm.validate()){
                        //     this.$store.dispatch('toggleSendCandidateFlag');
                        // }
                        this.$store.dispatch('closeModal');
                    }
                })
                .catch((error) => {
                    this.fetchingSc = false;
                    this.$store.dispatch('endLoading');
                    
                    this.$store.dispatch('openMessageBox', {
                        message: 'Unable to load staged candidate.',
                        code:  (error.responseStatus ? error.responseStatus.message : error),
                        okayText: 'Continue',
                        okayFunction: () => {
                        }
                    });
                });

            },
            createNew() {
                this.$store.commit('unlinkExternalId');
                this.$store.dispatch('closeModal');
            }
        }
    }
</script>

<style scoped>

    .duplicates {margin-top: 1.5rem; -webkit-box-shadow: 0.2rem 0.2rem 0.75rem 0px rgba(0, 0, 0, 0.25); box-shadow: 0.2rem 0.2rem 0.75rem 0px rgba(0, 0, 0, 0.25)}

    .duplicates > .duplicate + .duplicate {border-top: solid 1px #232323;}

</style>